<h2 mat-dialog-title style="text-align: center;">Declaração de PAD</h2>

<mat-dialog-content>
  <div class="certidao-dialog-grid">
    <p><strong>Data da consulta:</strong> {{ dataConsultaFormatada }}</p>
    <p><strong>Consultado:</strong> {{ consultadoLabel }}</p>
    <p><strong>Situação da Declaração:</strong> {{ situacaoLabel }}</p>
  </div>

  <div *ngIf="data.situacao === 'possui_pendencias' && data.mensagemPendencias" class="mensagem-pendencias">
    <p class="mensagem-pendencias-titulo">ATENCAO</p>
    <p class="mensagem-pendencias-texto">{{ data.mensagemPendencias }}</p>
  </div>

  <!-- Tabela de processos: visível para todos quando há processos -->
  <ng-container *ngIf="showProcessTable">
    <h4 class="admin-section-title">
      Processos encontrados
      <span class="processos-hint">(selecione os que devem constar na declaração)</span>
    </h4>

    <div class="tabela-processos">
      <table>
        <thead>
          <tr>
            <th class="col-check">
              <mat-checkbox [checked]="todosSelecionados" [indeterminate]="algumSelecionado && !todosSelecionados"
                (change)="toggleTodos()" title="Selecionar todos"></mat-checkbox>
            </th>
            <th>Processo</th>
            <th>Órgão</th>
            <th>Status</th>
            <th>Detalhe</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let p of processosUnificados" [class.row-selecionada]="processosSelecionados.has(p.numero)">
            <td class="col-check">
              <mat-checkbox [checked]="processosSelecionados.has(p.numero)"
                (change)="toggleProcesso(p.numero)"></mat-checkbox>
            </td>
            <td>{{ p.numero }}</td>
            <td>{{ p.orgao || '-' }}</td>
            <td>{{ p.status || '-' }}</td>
            <td>{{ p.detalhe || '-' }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <p *ngIf="!algumSelecionado" class="aviso-selecao">
      Selecione ao menos um processo para emitir a declaração positiva.
    </p>
  </ng-container>

  <!-- Observações: apenas para administrador com pendências -->
  <ng-container *ngIf="showAdminExtras">
    <mat-form-field appearance="outline" class="observacoes-field">
      <mat-label>Observações da declaração</mat-label>
      <textarea matInput [(ngModel)]="observacoes" rows="3"
        placeholder="Observações que constarão do corpo da declaração positiva"></textarea>
    </mat-form-field>
  </ng-container>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="sair()">Sair</button>
  <button *ngIf="emissaoCompleta && data.situacao === 'possui_pendencias'" mat-stroked-button color="warn"
    (click)="emitirNadaConsta()">
    Emitir Nada Consta
  </button>
  <button *ngIf="podeMostrarBotaoEmitir" mat-raised-button color="primary" (click)="emitirESair()">
    Emitir
  </button>
</mat-dialog-actions>